module.exports = __webpack_public_path__ + "static/media/score.e9e9e4a0.png";